import { Routes, Route } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoute";
import { GuestRoute } from "./GuestRoute";
import { AppLayout } from "@/components/layout/AppLayout";
import LoginPage from "@/pages/auth/LoginPage";
import CreateProfilePage from "@/pages/create-profile/CreateProfilePage";
import NotFoundPage from "@/pages/NotFoundPage";
import LandingLayout from "@/components/layout/LandingPageLayout";
import DiscoverPage from "@/pages/discover/DiscoverPage";
import PorfileDiscoverPage from "@/pages/porfilediscover/PorfileDiscoverPage";
import SettingsPage from "@/pages/mysupport/SettingsPage";
import SignupPage from "@/pages/signup/SignupPage";
import SignupCompanyDetailsPage from "@/pages/signup/SignupCompanyDetailsPage";
import SignupDocumentsPage from "@/pages/signup/SignupDocumentsPage";
import AnonymousProfile from "@/components/shared/AnonymousCompanyProfile/AnonymousProfile";
import RegistrationSuccessPage from "@/pages/signup/RegistrationSuccessPage";
import ForgotPassword from "@/pages/forgot-password/ForgotPassword";
import VerifyEmailPage from "@/pages/verify-email/VerifyEmail";
import ResendEmail from "@/pages/resend-email/ResendEmail";
import MyProfilePage from "@/pages/profile/MyProfilePage";
import InterestsPage from "@/pages/interests/InterestsPage";
import CollaborationsPage from "@/pages/collaborations/CollaborationsPage";
import ShortlistPage from "@/pages/shortlist/ShortlistPage";
import InvoicesPage from "@/pages/invoices/InvoicesPage";
import WalletPage from "@/pages/invoices/WalletPage";
import ResetPassword from "@/pages/reset-password/ResetPassword";
import EditProfile from "@/pages/edit-profile/EditProfile";
import InterestPage from "../pages/interests/InterestDiscovery";
import Maintenance from "@/pages/maintenance/Maintenance";
import MatchSuccessPage from "@/pages/interests/components/ItsaMatchPage";
import PaymentSuccessPage from "@/pages/interests/components/PaymentSuccessPage";
import CollaborationWorkspacePage from "@/pages/collaborations/CollaborationWorkspacePage";
import MatchedProfileView from "@/pages/profile/MatchedView";
import NdaPage from "@/pages/nda/NdaPage";
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import { AdminProtectedRoute } from "./AdminProtectedRoute";
import { AdminLayout } from "@/components/layout/AdminLayout";
import AdminDashboardPage from "@/pages/admin/company-lists/AdminDashboardPage";
import AdminCollaborationTable from "@/pages/admin/collaboration-lists/AdminCollaborationTable";
import AdminDiscoverTable from "@/pages/admin/discover-listings/AdminDiscoverTable";
import AdminGuidancePage from "@/pages/admin/guidance-table/AdminGuidancePage";
import AdminCompanyDetailView from "@/pages/admin/company-lists/components/AdminMatchedView";
import AdminCollaborationDetailPage from "@/pages/admin/collaboration-lists/components/WorkspaceView";
import AdminInterestManagement from "@/pages/admin/interest-management/InterestManagement";
import CreditsPage from "@/pages/credits/CreditsPage";
import BuyCreditsPage from "@/pages/credits/components/BuyCreditsPage";

function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route element={<GuestRoute />}>
        <Route element={<LandingLayout />}>
          <Route path="/" element={<DiscoverPage />} />
          <Route path="/discover/:id" element={<AnonymousProfile pageID="DISCOVER_PUBLIC" />} />
        </Route>
      </Route>
      <Route path="/registration-success" element={<RegistrationSuccessPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/signup/company-details" element={<SignupCompanyDetailsPage />} />
      <Route path="/signup/documents" element={<SignupDocumentsPage />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/resend-email" element={<ResendEmail />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* Protected routes with AppShell layout */}
      <Route
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/create-profile" element={<CreateProfilePage />} />
        <Route path="/profile" element={<MyProfilePage />} />
        <Route path="/my-discovery" element={<PorfileDiscoverPage />} />
        <Route path="/my-discovery/:id" element={<AnonymousProfile pageID="DISCOVER_LOGGED_IN" />} />
        <Route path="/requests" element={<InterestsPage />} />
        <Route path="/collaborations" element={<CollaborationsPage />} />
        <Route path="/shortlist" element={<ShortlistPage />} />
        <Route path="/shortlist/:id" element={<AnonymousProfile pageID="SHORTLIST" />} />
        <Route path="/credits" element={<CreditsPage />} />
        <Route path="/credits/buy" element={<BuyCreditsPage />} />
        <Route path="/invoices" element={<InvoicesPage />} />
        <Route path="/invoices/wallet" element={<WalletPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/profile/edit" element={<EditProfile />} />
        <Route path="/requests/:id" element={<InterestPage />} />
        <Route path="/requests/:id/nda" element={<NdaPage />} />
        <Route path="/requests/match-success/:id" element={<MatchSuccessPage />} />
        <Route path="/requests/payment-success/:id" element={<PaymentSuccessPage />} />

        <Route path="/collaborations/:id" element={<CollaborationWorkspacePage />} />
        <Route path="/collaborations/:id/profile" element={<MatchedProfileView />} />
      </Route>

      {/* ============ Admin routes ============ */}
      <Route path="/admin/login" element={<AdminLoginPage />} />

      <Route
        element={
          <AdminProtectedRoute>
            <AdminLayout />
          </AdminProtectedRoute>
        }
      >
        <Route path="/admin/companies" element={<AdminDashboardPage />} />
        <Route path="/admin/collaborations" element={<AdminCollaborationTable />} />
        <Route path="/admin/interest" element={<AdminInterestManagement />} />
        <Route path="/admin/discover" element={<AdminDiscoverTable />} />
        <Route path="/admin/resource" element={<AdminGuidancePage />} />
        <Route path="/admin/companies/:id" element={<AdminCompanyDetailView />} />
        <Route path="/admin/collaborations/:id" element={<AdminCollaborationDetailPage />} />
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
      <Route path="/maintenance" element={<Maintenance />} />
    </Routes>
  );
}

export default AppRoutes;
